import { render } from "./RecordDialog.vue?vue&type=template&id=503447cf&scoped=true"
import script from "./RecordDialog.vue?vue&type=script&lang=js"
export * from "./RecordDialog.vue?vue&type=script&lang=js"

import "./RecordDialog.vue?vue&type=style&index=0&id=503447cf&lang=scss&scoped=true"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503447cf"]])

export default __exports__